import { useApolloClient, useMutation } from "@apollo/client";
import gql from "graphql-tag";
import Cookies from "js-cookie";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { LoginLayout } from "../Layout/Layout";
import { LoginContainer } from "../Login/LoginContainer/LoginContainer";
import "./Logout.css";

export const Logout = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [userSignOut] = useMutation(signOutMutation);
  const client = useApolloClient();

  const signOut = () => {
    userSignOut()
      .then(async () => {
        await client.clearStore();
        Cookies.remove("access_level");
      })
      .catch((err) => {
        console.error("Error", err);
      })
      .finally(() => {
        history.push("/login");
      });
  };

  useEffect(() => {
    signOut();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <LoginLayout>
      <LoginContainer title="loginForm.logout">
        <div>{t("logout.logoutMessage")}</div>
      </LoginContainer>
    </LoginLayout>
  );
};

const signOutMutation = gql`
  mutation signOutMutation {
    userLogout
  }
`;
